<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  suggestions: {
    type: Array,
    default: () => [],
  },
  helper: {
    type: String,
    default: '',
  },
});

const modelValue = defineModel({
  type: Array,
  default: () => [],
});

const customTag = ref('');

function normalize(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

const availableSuggestions = computed(() =>
  props.suggestions.filter(item => !modelValue.value.includes(item.value))
);

function add(value) {
  const normalized = normalize(value);
  if (!normalized || modelValue.value.includes(normalized)) return;
  modelValue.value = [...modelValue.value, normalized];
}

function addCustom() {
  add(customTag.value);
  customTag.value = '';
}

function remove(value) {
  modelValue.value = modelValue.value.filter(item => item !== value);
}
</script>

<template>
  <div>
    <p v-if="helper" class="text-xs text-n-slate-10">{{ helper }}</p>
    <div v-if="modelValue.length" class="mt-2 flex flex-wrap gap-2">
      <span v-for="tag in modelValue" :key="tag" class="inline-flex h-7 items-center gap-1 rounded-md bg-n-alpha-2 px-2 text-xs text-n-slate-12">
        {{ tag }}
        <button type="button" :title="`Remover ${tag}`" class="i-lucide-x size-3 text-n-slate-10" @click="remove(tag)" />
      </span>
    </div>
    <div v-if="availableSuggestions.length" class="mt-3">
      <p class="text-xs font-medium text-n-slate-11">Assuntos sugeridos</p>
      <div class="mt-2 flex flex-wrap gap-2">
        <button v-for="item in availableSuggestions" :key="item.value" type="button" class="inline-flex h-7 items-center gap-1 rounded-md border border-n-weak px-2 text-xs text-n-slate-11 hover:bg-n-alpha-1" @click="add(item.value)">
          <span class="i-lucide-plus size-3" />
          {{ item.label }}
        </button>
      </div>
    </div>
    <div class="mt-3 flex max-w-md gap-2">
      <input v-model="customTag" class="h-9 min-w-0 flex-1 rounded-md border border-n-weak bg-n-alpha-1 px-3 text-sm" placeholder="Adicionar outro assunto" @keydown.enter.prevent="addCustom" />
      <button type="button" title="Adicionar assunto" class="inline-flex size-9 shrink-0 items-center justify-center rounded-md border border-n-weak text-n-slate-11 hover:bg-n-alpha-1" @click="addCustom">
        <span class="i-lucide-plus size-4" />
      </button>
    </div>
  </div>
</template>
